const normalizeHostname = (hostname: string | undefined): string =>
  hostname?.trim().toLowerCase() ?? '';

export const PLATFORM_ADMINISTRATION_HOST = normalizeHostname(
  import.meta.env.VITE_PLATFORM_ADMINISTRATION_HOST
);

/**
 * Tenant Administration is available only on the single hostname selected at
 * build time. An empty value disables the frontend administration surface.
 */
export const isPlatformAdministrationHost = (
  hostname = window.location.hostname,
  administrationHost = PLATFORM_ADMINISTRATION_HOST
): boolean => {
  const normalizedHostname = normalizeHostname(hostname);
  const normalizedAdministrationHost = normalizeHostname(administrationHost);

  return (
    !!normalizedAdministrationHost &&
    normalizedHostname === normalizedAdministrationHost
  );
};
